/**
 * @description 判断是否是测试环境
 * @returns boolean
 */
// eslint-disable-next-line no-useless-escape
const isTest = (): boolean => /[^\.-]+-t\d+\.duitang\.net/.test(window.location.host);

export default isTest;
